import React from 'react';
import { style } from 'typestyle';
import { px } from 'csx';

import { ArtistSchema } from '../../../types/schema';
import { spacing } from '../../../theme/spacing';
import { TruncatedText } from '../molecules/TruncatedText';
import { ArtistProfileImage } from '../molecules/ArtistProfileImage';
import { mediaDesktop } from '../utilities/mediaQueries';
import { ArtistPlaylists } from './ArtistPlaylists';

export interface ArtistSidebarProps {
  artist: ArtistSchema;
  similarArtists: Array<ArtistSchema>;
}

const styles = {
  artistImage: style(
    {
      maxWidth: px(236),
    },
    mediaDesktop({
      margin: '0 auto',
      maxWidth: px(315),
    })
  ),
  contentSection: style({
    $nest: {
      '& + &': {
        marginTop: spacing.XXLARGE,
      },
    },
  }),
};

export const ArtistSidebar: React.FC<ArtistSidebarProps> = ({ artist }) => {
  return (
    <>
      <ArtistProfileImage artist={artist} className={styles.artistImage} />

      {artist.description.length > 0 && (
        <div className={styles.contentSection}>
          <h3>Artist bio</h3>
          <TruncatedText content={artist.description} />
        </div>
      )}

      <ArtistPlaylists artist={artist} />
    </>
  );
};
